import { render, staticRenderFns } from "./add-pauta-disciplina.vue?vue&type=template&id=ed5f9a84&"
import script from "./add-pauta-disciplina.vue?vue&type=script&lang=js&"
export * from "./add-pauta-disciplina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports